import isNullish from "./isNullish";

export const pluralize = (str, count = 1, options = {}) => {
  const { suffix = "s" } = options;
  return count === 1 ? str : `${str}${suffix}`;
};

export const isAreVerb = (count) => (count === 1 ? "is" : "are");

export const toSentenceCase = (str, preserveCase = false) => {
  if (isNullish(str) || typeof str !== "string") return "";

  const rest = preserveCase ? str.slice(1) : str.slice(1).toLowerCase();
  return str.charAt(0).toUpperCase() + rest;
};

export const toTitleCase = (str = "") =>
  str
    .split(/\s+/)
    .map((word) => (word ? word.charAt(0).toUpperCase() + word.slice(1) : word))
    .join(" ");

export const capitalize = (str = "") => {
  if (!str?.length) return str;

  return str.split(/(\s)+/).reduce((s, chunk) => {
    return s + chunk.trim().length > 1 ? toSentenceCase(chunk) : chunk;
  }, "");
};

export const unCamelCase = (str = "") => {
  return str
    .replace(/([A-Z])/g, " $1")
    .toLowerCase()
    .trim();
};

export const camelize = (str = "") => {
  return str
    .toLowerCase()
    .replace(/[_-]([a-z])/g, (_, char) => char.toUpperCase());
};
